/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-06-13T14:21:39-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-01T14:45:42-07:00
 */



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, box, color } from '../../style';
import Container from '../blocks/Container';
import Button from '../blocks/Button';
import { SUNSET_DATE } from '../../config/Master';


const style = StyleSheet.create({
  container: {
    ...box,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    ...spacing.PADDING_MD,
    backgroundColor: '#FFF',
  },

  sendLink: {
    color: color.BRAND_1,
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  warning: {
    backgroundColor: 'rgb(244, 205, 88)',
    color: 'rgb(117, 90, 8)'
  }


})

const Panel = (props) => {
  // const defaultMsg = <div>
  //   Please confirm your email address to continue using MissTravel. <a style={{whiteSpace: 'nowrap'}} className={css(style.sendLink)} onClick={props.resendEmail}>Resend confirmation email</a>
  // </div>

  const defaultMsg = <div>
    Our platform will sunset on {SUNSET_DATE}, and will no longer be accepting payments. We want to thank you for letting us be a part of your journeys.
  </div >

  return (
    <div className={css(style.container, props.type && style[props.type])}>
      <Container>
        <div style={{ textAlign: 'center' }}>
          {props.children ? props.children : defaultMsg}
        </div>
      </Container>
    </div>
  )
}



export default Panel;



// WEBPACK FOOTER //
// ./src/components/common/NagBar.jsx